import { DeepLinkType } from '@gem/models/deeplinksModel';
import { useTranslation } from '@gem/modules/i18n';

interface IDeepLinkViewActionPresenterParams {
  deepLinkType: DeepLinkType;
  appLink: string;
}

interface IDeepLinkViewActionPresenter {
  subtitle: string;
  title: string;
  onMainActionClick(): void;
}

export function useDeepLinkViewActionPresenter(
  params: IDeepLinkViewActionPresenterParams
): IDeepLinkViewActionPresenter {
  const { t } = useTranslation();

  const presenter: IDeepLinkViewActionPresenter = {
    get subtitle(): string {
      switch (params.deepLinkType) {
        case DeepLinkType.Room:
          return t('deeplink_subtitle_call');
        case DeepLinkType.Group:
          return t('deeplink_subtitle_chat');
        case DeepLinkType.Unknown:
        default:
          return '';
      }
    },

    get title(): string {
      return PROJECT_CONFIG.projectName;
    },

    onMainActionClick(): void {
      window.location.assign(params.appLink);
    },
  };
  return presenter;
}
